export const ImageColorModel = {
    GREY: 'GREY',
    GREYA: 'GREYA',
    RGB: 'RGB',
    RGBA: 'RGBA',
    BINARY: 'BINARY',
};
export const colorModels = {
    GREY: {
        components: 1,
        alpha: false,
        channels: 1,
    },
    GREYA: {
        components: 1,
        alpha: true,
        channels: 2,
    },
    RGB: {
        components: 3,
        alpha: false,
        channels: 3,
    },
    RGBA: {
        components: 3,
        alpha: true,
        channels: 4,
    },
    BINARY: {
        components: 1,
        alpha: false,
        channels: 1,
    },
};
//# sourceMappingURL=colorModels.js.map